import * as React from 'react';

import { AspectRatio } from './components/ui/aspect-ratio.js';

export function DimeAspectRatio({ ...props }: Readonly<React.ComponentProps<typeof AspectRatio>>) {
  return <AspectRatio {...props} />;
}
